import { ElementRef, Injectable } from '@angular/core';
import { google } from 'google-maps';
import { OtherService } from '@services/other.service';
import { ILocForGoogleMap, LocForGoogleMapClass } from '@classes/Location';
import { BehaviorSubject } from 'rxjs';
import { ILocation } from '@models/location';

import axios from 'axios';
// declare var axios: any;

export type TTypeTimezone = 'Utc' | 'User' | 'Game'; // в проекте 3 типа таймзоны.

export interface IResponseTimezone {
  dstOffset: number; // 3600
  rawOffset: number; // -21600
  status: string; // "OK"
  timeZoneId: string; // "America/Chicago"
  timeZoneName: string; // "Central Daylight Time"
}

export interface ITimezone {

  abbrev: string; // 'CDT'
  id: string; // 'Central Daylight Time'
  name: string; // 'America/Chicago'
  value: number;
}

export interface IGeoAddress {
  house?: string; // номер дома
  street?: string; // улица
  districtOfCity?: string; // район города
  building?: string;
  city?: string; // город
  state?: string; // штат/регион
  country?: string; // страна
  zipcode?: string; // индекс
  fullAddress?: string; // полный адрес тесктом
  place_id?: string; // уникальный ключ локации типа такого 'UYT43KUHGBsjhJHA'
  coords?: google.maps.LatLngLiteral; // координаты
  latLng?: google.maps.LatLng; // координаты
  states?: Array<string>; // [ регион страны, район региона ]
  id?: string;
}

export type TCoordsForBuildRoute = string | google.maps.LatLng | google.maps.LatLngLiteral | google.maps.Place;

@Injectable({ providedIn: 'root' })
export class Geo {

  apiKeyTimeZone = 'AIzaSyDn8BKUdA8K5Pgs9KdvCJf-0djrVXlTLWQ';

  private map?: Promise<Readonly<google.maps.Map<Element>>>;
  private mapOptions?: google.maps.MapOptions;

  private addressUser: IGeoAddress | null = null;


  private markers: Array<google.maps.Marker> = [];

  // === GOGGLE MAP ====================
  divForMap?: ElementRef;
  markerLogo?: string;
  private locationForGoogleMapSub$ = new BehaviorSubject<ILocForGoogleMap>(new LocForGoogleMapClass());
  locationForGoogleMap$ = this.locationForGoogleMapSub$.asObservable();

  constructor(
    private otherS: OtherService,
  ) {
  }

  // === GOGGLE MAP ====================
  goToGoogleMap() {
    window.open(`https://www.google.com/maps/place/?q=place_id:${this.locForGoggleMap?.placeIdOfGame}`, '_blank');
  }

  checkLocForGoggleMapFromILocation(isDrawMap: boolean, loc?: ILocation, divForMap?: ElementRef, markerLogo?: string): void {
    this.divForMap = divForMap;
    if (markerLogo) this.markerLogo = markerLogo;
    if (loc?.street) {
      this.locForGoggleMap = { address: `${loc?.city}, ${loc?.street}, ${loc?.state}, ${loc?.zipcode}` };
      if (this.locForGoggleMap?.address) this.drawMap111(isDrawMap);
    } else {
      this.locForGoggleMap = new LocForGoogleMapClass();
    }
  }

  get locForGoggleMap(): ILocForGoogleMap {
    return this.locationForGoogleMapSub$.getValue();
  }

  set locForGoggleMap(locForGoggleMap: ILocForGoogleMap) {
    this.locationForGoogleMapSub$.next({ ...this.locForGoggleMap, ...locForGoggleMap });
  }

  private drawMap111(isDrawMap = true): void {
    if (!this.locForGoggleMap?.address) return;
    if (isDrawMap && this.divForMap) {
      this.divForMap.nativeElement.style.height = +this.divForMap!.nativeElement.offsetWidth + 'px';
    }
    const markers: Array<string> = [];
    this.markerLogo ? markers.push(this.markerLogo) : markers.push('/assets/geo-1.svg');
    this.drawMapForGameInfo(this.divForMap?.nativeElement, this.locForGoggleMap?.address!, markers, isDrawMap).then(res => {
      if (res?.place_id) this.locForGoggleMap = { placeIdOfGame: res.place_id };
      if (res?.distance) this.locForGoggleMap = { distanceFromUserToGame: res.distance };
    });
  }


  drawMapForGameInfo(elRef: Element, address: string, markers: Array<string>, isDrawMap = true): Promise<{
    place_id: string,
    distance: string
  }> {

    const customStolesForMap: google.maps.MapTypeStyle[] = [
      { featureType: 'administrative', stylers: [{ color: '#e1ebf8' }] },

      { featureType: 'landscape', stylers: [{ color: '#e1ebf8' }] },

      { elementType: 'labels.text.fill', stylers: [{ color: '#4e545f' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#e1ebf8' }] },

      { featureType: 'poi', stylers: [{ color: '#d6dfef' }] },
      { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }, 
      { featureType: 'poi.school', stylers: [{ color: '#d6dfef' }] },
      { featureType: 'poi.park', stylers: [{ color: '#cad2e2' }] },
      { featureType: 'poi.sports_complex', stylers: [{ color: '#d5deee' }] },

      { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#f3fdfd' }] },
      { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#f3fdfd' }] },
      { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#888f9b' }] },
      { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#bcc4d3' }] },

      { featureType: 'transit', stylers: [{ visibility: 'off' }] },

      { featureType: 'water', stylers: [{ color: '#aab2c0' }] },
    ];


    const drawMap = isDrawMap ? this.drawMap(elRef) : null;

    const userCoords: Promise<google.maps.LatLngLiteral | null> = this.getCurrentLocation()
      .then(geoCoords => this.geoCoordsToLatLngLiteral(geoCoords, 'coords'))
      .catch((res: null) => res);

    const addressOfGame: Promise<{ coords: google.maps.LatLngLiteral, place_id: string }> = this.getGeoAddress({ address })
      .then(geoAddressOfGame => ({
        coords: geoAddressOfGame.coords as google.maps.LatLngLiteral,
        place_id: geoAddressOfGame.place_id as string,
      }));

    return Promise.all([drawMap, userCoords, addressOfGame])
      .then(([map, coordsCurrentLoc, addressGame]) => {
        this.mapOptions = { center: addressGame.coords, zoom: 16, styles: customStolesForMap };/////////////
        this.addMarker(addressGame.coords, markers[0]);
        this.setBoundsOfMap();
        this.setMapOptions(this.mapOptions);



        if (coordsCurrentLoc) {
          return this.calcDistance({ location: coordsCurrentLoc }, { location: addressGame.coords })
            .then(res => ({ place_id: addressGame.place_id, distance: res }));
        } else {
          return { place_id: addressGame.place_id, distance: '' };
        }
      });
  }


  public getAddress(): Promise<IGeoAddress> {
    return new Promise<IGeoAddress>((resolve, reject) => {
      this.getCurrentLocation()
        .then(coords => {
          this.getGeoAddress({ location: { lat: coords.latitude, lng: coords.longitude } })
            .then(address => resolve(address))
            .catch((err) => reject(err));
        })
        .catch((err) => reject(err));
    });
  }

  public autoCompletePlaces(input: HTMLInputElement): void {
    const coordsCenterOfUsa: google.maps.LatLngLiteral = { lat: 40.696587, lng: -100.155468 };
    const center: google.maps.LatLngLiteral = coordsCenterOfUsa;
    // const defaultBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral = {
    //   north: center.lat + 15,
    //   south: center.lat - 15,
    //   east: center.lng + 25,
    //   west: center.lng - 25,
    // };
    const defaultBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral = {
      north: 72,   // Covers Alaska's northern tip
      south: 24,   // Covers southern Florida & Texas
      east: -66,   // Covers Maine and New York
      west: -125,  // Covers California and Washington
    };    
    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: 'us' },
      strictBounds: true,
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
  }

  public setAddressFromGoogle(str: string): Promise<{ [key: string]: any }> {

    let result: any = {};

    return new Promise<{ [p: string]: string }>((resolve, reject) => {
      this.getGeoAddress({ address: str })
        .then(fullAddress => {
          if (fullAddress) {
            result = {
              street: fullAddress.fullAddress!.trim().split(',')[0],
              city: fullAddress.fullAddress!.trim().split(',')[1],
              zipcode: fullAddress.zipcode as string,
              state: (fullAddress.states as Array<string>)[0],
              coords: fullAddress.coords,
            };
          }
          resolve(result);
        })
        .catch((err) => {
          reject(null);
        });
    });
  }

  public getTimezone(coords: { latitude?: number; longitude?: number }): Promise<ITimezone> {
    const config = {
      method: 'get',
      url: `https://maps.googleapis.com/maps/api/timezone/json?location=${coords.latitude}%2C${coords.longitude}&timestamp=${new Date().getTime() / 1000}&key=${this.apiKeyTimeZone}`,
      headers: {},
    };
    // return axios(config);
    return new Promise((resolve, reject) => {
      axios(config)
        .then((response: any) => {
          if (response?.data?.errorMessage) reject(response?.data?.errorMessage);
          if (response.status !== 200) reject(null);
          const res: IResponseTimezone = response?.data;
          const timezone = this.otherS.convertGoogleTimezoneToITimezone(res);
          resolve(timezone);
        })
        .catch((err: any) => reject(err));
    });
  }

  public getCoordsByZipcode(zipcode: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getGeoAddress({ address: zipcode })
        .then(res => resolve(res))
        .catch(() => reject(null));
    });
  }

  private geoCoordsToLatLngLiteral(coords: GeolocationCoordinates | IGeoAddress, str: 'coords' | 'address'): google.maps.LatLngLiteral {
    if (str === 'coords') {
      return {
        lat: (coords as GeolocationCoordinates).latitude,
        lng: (coords as GeolocationCoordinates).longitude,
      };
    } else {
      return (coords as IGeoAddress).coords as google.maps.LatLngLiteral;
    }
  }

  public getCurrentLocation(): Promise<GeolocationCoordinates> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve(pos.coords),
        (err) => { 
          reject(null);
        },
      );
    });
  }

  public getGeoAddress(request: google.maps.GeocoderRequest): Promise<IGeoAddress> {
    return new Promise<IGeoAddress>((resolve, reject) => {
      new google.maps.Geocoder().geocode(request, (results: Array<google.maps.GeocoderResult>, status: any) => {
        if (status == google.maps.GeocoderStatus.OK) {
          let geoResult = results.find(res => res.types?.find(type => type === 'street_address' || type === 'plus_code')) as google.maps.GeocoderResult;
          !geoResult && (geoResult = results[0]);
          const address = geoResult.address_components as google.maps.GeocoderAddressComponent[];
          this.addressUser = {
            fullAddress: geoResult.formatted_address, 
            place_id: geoResult.place_id, 
            latLng: (geoResult.geometry as google.maps.GeocoderGeometry).location, 
            coords: (geoResult.geometry as google.maps.GeocoderGeometry).location.toJSON(), 
          };
          address.forEach((addr) => {
            addr.types.forEach(type => {
              type === 'street_number' && (this.addressUser!.house = addr.long_name);
              type === 'route' && (this.addressUser!.street = addr.long_name);
              type === 'sublocality' && (this.addressUser!.districtOfCity = addr.long_name);
              type === 'locality' && (this.addressUser!.city = addr.long_name);
              type === 'country' && (this.addressUser!.country = addr.long_name);
              type === 'postal_code' && (this.addressUser!.zipcode = addr.long_name);
              if (type.includes('administrative_area_level')) {
                !this.addressUser!.states ? this.addressUser!.states = [addr.long_name]
                  : this.addressUser!.states.unshift(addr.long_name);
                this.addressUser!.state = this.addressUser!.states[0];
              }
            });
          });


          resolve(this.addressUser);
        } else {
          reject(null);
        }
      });
    });
  }

  public drawMap(elRef: Element, options?: any): Promise<google.maps.Map> { 
    const mapOptions = options || null;
    return this.map = new Promise(resolve => resolve(new google.maps.Map(elRef, mapOptions)));
  }

  public setMapOptions(options: google.maps.MapOptions): void {
    this.mapOptions = { ...options };
    this.map?.then((map) => {
      map.setOptions(this.mapOptions as google.maps.MapOptions);
    });
  }

  public drawMapAndBuildRoute(start: TCoordsForBuildRoute, end: TCoordsForBuildRoute, elRef?: Element): void {
    if (!this.map && elRef) this.drawMap(elRef);
    this.map?.then(map => {
      const service = new google.maps.DirectionsService();
      const renderer = new google.maps.DirectionsRenderer();
      renderer.setMap(map);
      let request = {
        origin: start,
        destination: end, 
        travelMode: google.maps.TravelMode.DRIVING, // BICYCLING | DRIVING | TRANSIT | TWO_WHEELER | WALKING
      };
      service.route(request, res => renderer.setDirections(res));
    });
  }

  public addMarker(coords: google.maps.LatLngLiteral, imgName?: string): void {
    this.map?.then((map) => {

      const icon = {
        url: imgName,
        scaledSize: new google.maps.Size(30, 30),
      };

      const marker = new google.maps.Marker({
        position: coords,
        icon: icon,
        map: map,
        optimized: false, 
      } as google.maps.ReadonlyMarkerOptions);
    });
  }

  public setBoundsOfMap(): void {
    this.map?.then(map => {
      const bounds = new google.maps.LatLngBounds();
      this.markers.forEach(marker => bounds.extend(marker.getPosition() as google.maps.LatLng));
      map.fitBounds(bounds);
    });
  }

  public addInfoWindow(coords: google.maps.LatLngLiteral, text: string): void {
    this.map?.then(map => {
      new google.maps.InfoWindow({
        map: map,
        content: text,
        position: coords,
      } as google.maps.InfoWindowOptions);
    });
  }

  public calcDistance(address1: google.maps.GeocoderRequest, address2: google.maps.GeocoderRequest): Promise<string> {
    const coords1 = new Promise(resolve => this.getGeoAddress(address1).then(geoAddress => resolve(geoAddress.latLng)));
    const coords2 = new Promise(resolve => this.getGeoAddress(address2).then(geoAddress => resolve(geoAddress.latLng)));
    return Promise.all([coords1, coords2] as Array<Promise<google.maps.LatLng>>).then(res => {
      return (google.maps.geometry.spherical.computeDistanceBetween(res[0], res[1]) / 1000).toFixed(3);
    });
  }

}
